<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col cols="12" sm="4" md="3" lg="2" xl="1" class="nav-left d-none d-sm-block">
                    <SideMenu />
                </v-col>
                <v-col cols="12" sm="8" md="9" lg="10" xl="11" class="nav-right pl-xl-10 pt-12 pb-16">
                    <!-- <v-row justify="center" align="start"> -->
                    <v-data-table
                        :headers="headers"
                        :items="list"
                        sort-by="code"
                        :loading="isLoading"
                        loading-text="Cargando los códigos"
                        :expanded.sync="expanded"
                        item-key="code"
                        single-expand
                        show-expand
                        class="elevation-0 pl-10 pl-md-3 pl-xl-16 pb-16"
                        fixed-header
                        :items-per-page="itemsPerPage"
                        :search="search"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Administrador de Descuentos</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    class="elevation-0"
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Buscar"
                                    single-line
                                    hide-details
                                ></v-text-field>
                                <v-btn
                                    color="primary"
                                    dark
                                    small
                                    fab
                                    class="mb-2 mx-2"
                                    @click="updateDiscount()"
                                >
                                    <v-icon>
                                        mdi-refresh
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    dark
                                    small
                                    fab
                                    class="mb-2"
                                    @click="createCode()"
                                >
                                    <v-icon>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                                <v-dialog v-model="dialog" max-width="500px" persistent>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{formTitle}}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            v-model="itemDefault.code"
                                                            label="Código"
                                                            :disabled="blockField"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-row class="ma-1">
                                                        <v-col cols="12" class="my-0 py-0">
                                                            <v-label>
                                                                Vencimiento
                                                            </v-label>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-text-field
                                                                v-model="dateToCreate"
                                                                hide-details
                                                                label="Fecha"
                                                                type="date"
                                                            />
                                                        </v-col>
                                                        <v-col>
                                                            <v-text-field
                                                                v-model="timeToCreate"
                                                                hide-details
                                                                label="Hora"
                                                                type="time"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                    <v-col cols="6">
                                                        <v-select
                                                            v-model="itemDefault.packs"
                                                            :items="packsToSale"
                                                            item-text="name"
                                                            item-value="code"
                                                            label="Packs"
                                                            multiple
                                                        >
                                                        </v-select>
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-text-field
                                                            v-model="itemDefault.times"
                                                            type="number"
                                                            label="Veces de uso"
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                    
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            v-model="userToAdd"
                                                            label="Usuarios Habilitados"
                                                        >
                                                            <v-icon
                                                              slot="append"
                                                              @click="addUser(userToAdd)"
                                                            >
                                                                mdi-plus
                                                            </v-icon>
                                                        </v-text-field>
                                                        <v-chip
                                                            v-for="(user, index) in itemDefault.users"
                                                            :key="index"
                                                            small
                                                        >
                                                            {{user}}
                                                            <v-icon
                                                                small
                                                                @click="deleteUser(index)"
                                                            >
                                                                mdi-delete
                                                            </v-icon>
                                                        </v-chip>
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-text-field
                                                            v-model="discountTocreate"
                                                            type="number"
                                                            label="Descuento"
                                                            append-icon="%"
                                                        >
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close()">
                                                Cancelar
                                            </v-btn>
                                            <v-btn color="blue darken-1" text @click="save()">
                                                Guardar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:loading>
                            <div style="margin-top: 20px !important; margin-bottom: 600px !important;">
                                Cargando Codigos...
                            </div>
                        </template>
                        <template v-slot:item.users="{ item }">
                            <div v-if="item.users && item.users.length === 0">
                                <ul class="px-0">
                                    <v-chip small label class="ma-1">
                                        TODOS
                                    </v-chip>
                                </ul>
                            </div>
                            <div v-else>
                                <ul v-for="(user, index) in item.users" :key="index" class="px-0">
                                    <v-chip small label class="ma-1">
                                        {{user}}
                                    </v-chip>
                                </ul>
                            </div>
                        </template>
                        <template v-slot:item.expireAt="{ item }">
                            {{ item.expireAt !== undefined ? formatDate(item.expireAt) : "----------"}}
                        </template>
                        <template v-slot:item.packs="{ item }">
                            <ul v-for="(pack, index) in item.packs" :key="index" class="px-0">
                                <v-chip  small label class="ma-1">
                                    {{packName(pack)}}
                                </v-chip>
                            </ul>
                        </template>
                        <template v-slot:item.discount="{ item }">
                            {{ offValor(item.discount) }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteItemOpen(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="updateDiscount">
                                Reset
                            </v-btn>
                        </template>
                        <template v-slot:expanded-item="{ item }">
                            <v-container class="fix">
                                <v-simple-table dense fixed-header>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Email Usuario</th>
                                                <th>Usos</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(user, index) in used.filter(u => u.code === item.code)" :key="index">
                                                <td class="text-center">{{user.sort}}</td>
                                                <td class="text-center">{{user.count}}</td>
                                                <td class="text-center">
                                                    <v-icon small @click="deleteItemOpen(user)">
                                                        mdi-delete
                                                    </v-icon>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>                        
                            </v-container>
                        </template>
                    </v-data-table>
                                <!-- deleteItem({code: item.code, sort: user}) -->
                    <v-dialog
                        v-model="dialogDelete"
                        max-width="500px"
                    >
                        <v-card>
                            <v-card-title>
                                Se borrara: <br> 
                                Codigo: {{deleteItemObject && deleteItemObject.code}}
                                <br>
                                {{deleteItemObject && deleteItemObject.sort !== "config" ? `Usuario: ${deleteItemObject.sort}` : ""}}
                            </v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="dialogDelete = false">
                                    Cancelar
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItem(deleteItemObject)">
                                    Ok
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <!-- </v-row> -->
                </v-col>
            </v-row>
        </v-container>
        <Footer></Footer>
    </div>
</template>
<script>
import SideMenu from "@/components/SideMenu";
// import DatePicker from "@/components/DatePicker";
// import TimePicker from "@/components/TimePicker";
import { userComputed } from "@/store/helpers.js";
import { currentImg, datetime } from "@/libs/mixins";
import { mapGetters, mapState, mapActions } from "vuex";
import { packsDesc } from "@/config/fixtures";

export default {
    name: "AdminDiscount",
    components: {
        SideMenu,
        // DatePicker,
        // TimePicker
    },
    mixins: [currentImg, datetime],
    data() {
        return {
            // dialogDelete: false,
            formTitle: "",
            search: "",
            expanded: [],
            used: [],
            list: [],
            isLoading: false,
            headers: [
                {
                    text: "Codigo",
                    align: "start",
                    sortable: true,
                    value: "code"
                },
                { text: "Vencimiento", align: "start", value: "expireAt" },
                { text: "Packs", align: "start", value: "packs" },
                { text: "Veces", align: "start", value: "times" },
                { text: "Usuarios", align: "start", value: "users", sortable: false },
                { text: "Descuento", align: "start", value: "discount", sortable: true },
                { text: "Acciones", align: "start", value: "actions", sortable: false },
                { text: "", value: "data-table-expand" },
            ],
            dialog: false,
            dialogDelete: false,
            itemsPerPage: 10,
            itemDefault: {
                code: "",
                value: 1,
                expireAt: undefined,
                packs: ["B01I01"],
                users: [],
                times: 1,
                sort: "config"
            },
            userToAdd: "",
            dateToCreate: "",
            timeToCreate: "",
            discountTocreate: 100,
            blockField: false,
            deleteItemObject: null,
        };
    },
    created() {
        this.updateDiscount();
    },
    watch: {
        "itemDefault.code"() {
            this.itemDefault.code = this.itemDefault.code.toUpperCase();
        },
    },
    computed: {
        ...mapGetters("accounts", ["getDiscountsList", "getDiscountsUsed"]),
        ...userComputed,
        getMinDate() {
            let [year, month, day] = new Date().toISOString().substr(0, 10).split("-");
            let min = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).toISOString().substr(0, 10);
            return min;
        },
        packsToSale() {
            return packsDesc;
        },
        isValidCode() {
            if (this.itemDefault.code.length < 5) {
                return false;
            } else if (parseInt(this.discountTocreate) === 0 && parseInt(this.discountTocreate) > 101) {
                return false;
            } 
            return true;
        },
        getTimeStamp() {
            if (this.dateToCreate === "" || this.dateToCreate === null || this.dateToCreate === undefined) 
                return undefined;
            // const [ day, month, year ] = this.dateToCreate.split("/");
            // const [ hours, minutes ] = this.timeToCreate === "" ? "23:59".split(":") : this.timeToCreate.split(":");
            const [year, month, day] = this.dateToCreate.split("-");
            const [hours, minutes, seconds] = this.timeToCreate === "" ? "23:59".split(":") : this.timeToCreate.split(":");
            
            const ts = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes)).getTime() / 1000;
            
            return parseInt(ts);
        }
    },
    methods: {
        ...mapActions("accounts", ["discounts", "createDiscount", "removeDiscount"]),
        deleteItemOpen(item) {
            this.deleteItemObject = null;
            this.deleteItemObject = { ...item };
            this.dialogDelete = true;
        },
        createCode() {
            this.formTitle = "Crear Codigo";
            this.blockField = false;
            this.itemDefault = {
                code: "",
                value: 1,
                expireAt: undefined,
                packs: ["B01I01"],
                users: [],
                times: 1,
                sort: "config"
            };
            this.userToAdd = "";
            this.dateToCreate = "";
            this.timeToCreate = "";
            this.discountTocreate = 100;
            this.blockField = false;
            this.dialog = true;
        },
        editItem(item) {
            const dateTime = item && item.expireAt ? new Date(item.expireAt * 1000) : undefined;
            const [date, time] = dateTime.toLocaleString().split(" ");
            
            const [day, month, year] = date.split("-");
            const [hours, minutes, seconds] = time.split(":");
            
            this.blockField = true;
            this.formTitle = "Editar Código";
            this.itemDefault = item;
            this.itemDefault.value = item.discount; 
            this.discountTocreate = item.discount * 100;
            this.dateToCreate = `${year}-${month}-${day}`;
            this.timeToCreate = `${hours}:${minutes}:${seconds}`;
            
            this.dialog = true;
        },
        addUser(user) {
            this.itemDefault.users.push(user);
            this.userToAdd = "";
        },
        deleteUser(index) {
            this.itemDefault.users.splice(index, 1);
        },
        packName(packCode) {
            return packsDesc.find(pack => pack.code === packCode).name;
        },
        offValor(valor) {
            return `${valor * 100}%`;
        },
        formatDate(date) {
            const d = new Date(parseInt(date) * 1000);
            const dd = d.getDate();
            const MM = d.getMonth() + 1;
            const yyyy = d.getFullYear();
            
            const hh = d.getHours();
            const mm = d.getMinutes();
            const ss = d.getSeconds();
            return `${dd < 10 ? "0" + dd : dd}/${MM < 10 ? "0" + MM : MM}/${yyyy} ${hh < 10 ? "0" + hh : hh}:${mm < 10 ? "0" + mm : mm}:${ss < 10 ? "0" + ss : ss}`;
        },
        deleteItem(item) {
            this.isLoading = true;
            this.removeDiscount(item).then(() => {
                this.deleteItemObject = null;
                this.dialogDelete = false;
                this.isLoading = false;
                this.updateDiscount();
            }).finally(() => {
                this.deleteItemObject = null;
                this.dialogDelete = false;
                this.isLoading = false;
            });
        },
        updateDiscount() {
            this.isLoading = true;
            this.discounts().then(response => {
                this.used = this.getDiscountsUsed;
                this.list = this.getDiscountsList;
                this.isLoading = false;
            });
        },
        close() {
            this.itemDefault = {
                code: "",
                discount: 1,
                expireAt: undefined,
                packs: ["B01I01"],
                users: [],
                times: 1,
                sort: "config"
            };
            this.dateToCreate = "";
            this.timeToCreate = "";
            this.dialog = false;
        },
        save() {
            if (this.isValidCode) {
                this.itemDefault.expireAt = this.getTimeStamp;
                this.itemDefault.value = this.discountTocreate / 100;
                this.isLoading = true;
                this.createDiscount(this.itemDefault).then(() => {
                    this.itemDefault = {
                        code: "",
                        discount: 1,
                        expireAt: undefined,
                        packs: ["B01I01"],
                        users: [],
                        times: 1,
                        sort: "config"
                    };
                    this.dialog = false;
                    this.isLoading = false;
                }).finally(() => {
                    this.isLoading = false;
                    this.updateDiscount();
                });
            }
        },
        updateDate(value) {
            this.dateToCreate = value === undefined ? "" : value;
        },
        saveTime(value) {
            this.timeToCreate = value;
        }
    }
};
</script>
<style>
td {
    font-size: 12px !important;
}
</style>
